import axios, { AxiosPromise } from 'axios';

export const getToken = (): AxiosPromise<string> => {
    return axios.get('/api/MicrosoftCognitiveServicesSpeech/gettoken');
}